import NiceModal from '@ebay/nice-modal-react';
import { AdjustmentsVerticalIcon, Bars4Icon, EllipsisVerticalIcon, TrashIcon } from '@heroicons/react/24/outline';
import { createColumnHelper } from '@tanstack/react-table';
import { Link, useNavigate } from 'react-router';
import Button from '@/components/UI/Button';
import DropDown from '@/components/UI/DropDown';
import { PreviewModal } from '@/features/projects/components/Reports/PreviewModal';

type ReportItem = {
  id: number;
  name: string;
  description: string;
  createdAt: string;
  fileUrl: string;
};

const columnHelper = createColumnHelper<ReportItem>();

export const columns = [
  columnHelper.accessor('name', {
    header: 'Name',
    size: 150,
    cell: ({ cell, row }) => {
      return (
        <div className='flex gap-2'>
          <div className='relative'>
            <Link to={`${row.original.id}`} className='line-clamp-2 hover:underline hover:underline-offset-2 max-w-[220px]'>
              {cell.getValue()}
            </Link>
            <Button
              customClassName='absolute top-0 -right-20'
              btnStyle='btn-neutral'
              btnSize='sm'
              label='Preview'
              onClick={() => {
                NiceModal.show(PreviewModal, {
                  fileUrl: row.original.fileUrl,
                  title: row.original.name,
                });
              }}
            />
          </div>
        </div>
      );
    },
  }),
  columnHelper.accessor('description', {
    header: 'Description',
    size: 300,
  }),
  columnHelper.accessor('createdAt', {
    header: 'Date Created',
    size: 170,
  }),
  columnHelper.display({
    header: 'Actions',
    size: 90,
    cell: ({ row }) => {
      const navigate = useNavigate();

      return (
        <div>
          <DropDown
            menuItems={[
              {
                name: 'Generate',
                icon: <Bars4Icon className='w-5 h-5' />,
                clicked: () => {
                  navigate(`${row.original.id}`);
                },
              },
              {
                name: 'Settings',
                icon: <AdjustmentsVerticalIcon className='w-5 h-5' />,
                clicked: () => {
                  navigate(`${row.original.id}/settings`);
                },
              },
              {
                name: 'Archive',
                icon: <TrashIcon className='w-5 h-5' />,
                clicked: () => {},
              },
            ]}
          >
            <div className='flex items-center justify-center hover:bg-gray-200 active:bg-gray-300 rounded-md w-8 h-8 font-medium'>
              <EllipsisVerticalIcon className='h-4 w-4' />
            </div>
          </DropDown>
        </div>
      );
    },
  }),
];
